import Alpine from "alpinejs";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import LazyLoad from "vanilla-lazyload";
import { listen, prefetch } from "quicklink";

import Map from "./components/map";
import Header from "./components/header";
import Accordion from "./components/accordion";
import Faq from "./components/faq";
import Latestblock from "./components/latestblock";
import Storiesblock from "./components/storiesblock";
import Statsblock from "./components/statsblock";
import Stepsblock from "./components/stepsblock";
import Filteredcontent from "./components/filteredcontent";
import Contentgalleryblock from "./components/contentgalleryblock";
import Videoplayer from "./components/videoplayer";
import Partnerhover from "./components/partnerhover";
import Heroblock from "./components/heroblock";
import Heropageblock from "./components/heropageblock";
import Scrollanimation from "./components/scrollanimation";
import Textandfullscreenblock from "./components/textandfullscreenblock";
import Listcomplex from "./components/listcomplex";
import PageTransition from "./utils/pagetransition";
import { stripGuillemets } from "./utils/stripGuillemets";
import { initNewsletterTracking } from "./utils/matomo";
import { initAutoplayVideos } from "./utils/video";

import VideoPlayerStore from "./stores/videoPlayer";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

PageTransition();
stripGuillemets();
initNewsletterTracking();
initAutoplayVideos();

window.Alpine = Alpine;

window.lazyload = new LazyLoad({
  elements_selector: "[data-lazy]",
});

document.addEventListener("alpine:init", () => {
  VideoPlayerStore();

  Map();
  Header();
  Accordion();
  Faq();
  Latestblock();
  Storiesblock();
  Statsblock();
  Stepsblock();
  Filteredcontent();
  Contentgalleryblock();
  Videoplayer();
  Partnerhover();
  Heroblock();
  Heropageblock();
  Scrollanimation();
  Textandfullscreenblock();
  Listcomplex();

  listen();
});

Alpine.start();
